import {
  useEffect,
  useState,
} from 'react';

import { useSnackbar } from 'notistack';
import Dynamicore, { SERVICES } from 'services/dynamicore';
import { dynamicSort } from 'utils/arrays';

//Carga de datos de referencia para el control de edición de archivos y HTML, incluyendo campos mapeables y funciones de notificación.
export default function useSignerReferenceData() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState(null);
  const [functions, setFunctions] = useState();

  const fetchData = async () => {
    const result = await Dynamicore(SERVICES.DOCUMENTS_TEMPLATES_CLIENTS).get({
      type: 'all',
    });

    if (result.values && Array.isArray(result.values)) {
      const allFields = result.values.flatMap((value) => {
        const [firstEntry] = Object.entries(value);
        let fields = [];

        if (firstEntry && Array.isArray(firstEntry)) {
          const [, entry] = firstEntry;
          if (entry) {
            fields = entry.fields || entry;
          }
        }

        if (!Array.isArray(fields)) {
          fields = [];
        }
        const groupName = value.name || Object.keys(value)?.[0];
        return fields.map((field) => ({
          id: field.value,
          val: field.value,
          name: field.name,
          groupBy: groupName,
        }));
      });
      const sortedFields = allFields.sort(dynamicSort('groupBy', 'name'));
      setData(sortedFields);
    }
  };

  const loadFunctions = async () => {
    try {
      const response = await Dynamicore(SERVICES.NOTIFICATIONS_FUNCTIONS).get(
        {},
      );
      setFunctions(response.values || []);
    } catch (error) {
      enqueueSnackbar('Error al cargar las funciones de notificación', {
        variant: 'error',
      });
      setFunctions([]);
    }
  };

  useEffect(() => {
    loadFunctions();
    fetchData();
  }, []);

  return {
    data,
    functions,
  };
}
